module.exports = __webpack_public_path__ + "assets/svg/Icons/32/repeat-gray-944c35.svg";